import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { RadioButton, RadioButtonGroup } from 'suomifi-ui-components';

export const CoveredByInformationManagementAct = ({
  i18n,
  coveredByInformationManagementAct,
  formik
}) => {
  return (
    <RadioButtonGroup
      labelText={i18n(
        'intermediary.dataProtection.statementOnInformationSecurity'
      )}
      name="formData.statementOnInformationSecurity.coveredByInformationManagementAct"
      value={coveredByInformationManagementAct}
      onChange={value =>
        formik.setFieldValue(
          'formData.statementOnInformationSecurity.coveredByInformationManagementAct',
          value === 'true'
        )
      }
    >
      <RadioButton value="true">
        <FormattedMessage id="intermediary.common.yes" />
      </RadioButton>
      <RadioButton value="false">
        <FormattedMessage id="intermediary.common.no" />
      </RadioButton>
    </RadioButtonGroup>
  );
};

CoveredByInformationManagementAct.propTypes = {
  i18n: PropTypes.func,
  coveredByInformationManagementAct: PropTypes.string,
  formik: PropTypes.object
};
